import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { SessionService } from '../Util/Session/session.service';
import { CommonService } from '../Model/Common/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-approval-matrix-view',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './approval-matrix-view.component.html',
  styleUrl: './approval-matrix-view.component.scss'
})
export class ApprovalMatrixViewComponent {

  @Input() TransactionId = 0;
  @Input() EmployeeId = 0;
  @Input() RequestDate = '';
  @Input() ApprovalStatus = '';
  @Input() ModuleMasterId = 0;
  
  isDisabled: boolean = false;
  isApprovalLavel = true;

  TrackingsUser: any[] = [];
  Trackings: any[] = [];
  user: any;
  constructor(
    protected tooltip: TooltipService,
    private approvalMatrix: ApprovalMatrixService,
    private session: SessionService,
    public common: CommonService,
    private activeModal: NgbActiveModal
  ){
    this.user = session.GetUserDetails();
  }

  ngOnInit(){
    console.log(this.TransactionId);
    console.log(this.EmployeeId);
    this.ApprovalMatrixRequestGetTracking();
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.EmployeeId, EmpMappingId: 0, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close(){
    this.activeModal.close();
  }

}
